export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  EVOLUTION_STATUS_CHANGED: 'EVOLUTION_STATUS_CHANGED',
  KANBAN_MESSAGE_RECEIVED: 'KANBAN_MESSAGE_RECEIVED',
  KANBAN_CONVERSATION_UPDATED: 'KANBAN_CONVERSATION_UPDATED',
  KANBAN_CONVERSATION_CREATED: 'KANBAN_CONVERSATION_CREATED',
  KANBAN_CARD_MOVED: 'KANBAN_CARD_MOVED',
  KANBAN_SLOT_VALUE_COMPLETED: 'KANBAN_SLOT_VALUE_COMPLETED',
  KANBAN_SLOT_VALUES_RESET: 'KANBAN_SLOT_VALUES_RESET',
  KANBAN_SLOT_VALUES_NAVIGATED: 'KANBAN_SLOT_VALUES_NAVIGATED',
  KANBAN_FIELD_VALUE_UPDATED: 'KANBAN_FIELD_VALUE_UPDATED',
  SLOT_RESTRICTION_COMPILED: 'SLOT_RESTRICTION_COMPILED',
  SLOT_RESPONSE_INSTRUCTION_COMPILED: 'SLOT_RESPONSE_INSTRUCTION_COMPILED',
  OPEN_SCHEDULE_MODAL: 'OPEN_SCHEDULE_MODAL',
};
